module.exports=function anonymous(obj,microTemplate
) {
var p=[],print=function(){p.push.apply(p,arguments);};with(obj){p.push(''); accessLevelIds.forEach(function(levelId) { 
p.push('  <input type="hidden" name="',window.microTemplate.encodeHtml(inputFieldName),'" value="',window.microTemplate.encodeHtml(levelId),'" /> '); }); 
p.push(' <input type="hidden" name="',window.microTemplate.encodeHtml(noAccessFieldName),'" value="',window.microTemplate.encodeHtml(noAccessValue),'" /> ');}return p.join('');
}